import React, { useState } from "react";
import './lags.css';

function LagsForm({flightData, allData}) {
    const [isEditable, setIsEditable] = useState(false);
    // Campos del formulario
    const [uldXpPl, setUldXpPl] = useState("");
    const [pieces, setPieces] = useState("");
    const [weight, setWeight] = useState("");
    const [reason, setReason] = useState("");
    const [houses, setHouses] = useState([]);
    const [coordinator, setCoordinator] = useState("");
    const userData = localStorage.getItem('user');
    const user = JSON.parse(userData);

    const masterId = 1;
    const masterNumber = "123-526166622";
    const isDirect = false;
    const userName = user.first_name+" "+user.last_name;

    const handleCheckboxChange = (e) => {
        setIsEditable(e.target.checked);
    };

    const handleSave = () => {
        const finalData = {
            exp_master_ids: {
                [masterId]: "master-id-123" // simulado
            },
            awb: {
                [masterId]: masterNumber
            },
            exp_houses: {
                [masterId]: houses
            },
            uld_xp_pls: {
                [masterId]: uldXpPl
            },
            pieceses: {
                [masterId]: pieces
            },
            weights: {
                [masterId]: weight
            },
            reasons: {
                [masterId]: reason
            },
            lag_checks: {
                [masterId]: isEditable
            },
            user: userName,
            coordinator: coordinator
        };
        console.log("Datos simulados enviados al backend:", finalData);
    }

    return(
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-3">
                        <p><span className="fw-bold">Vuelo:</span> {flightData.flight} </p>
                    </div>
                    <div className="col-3">
                        <p><span className="fw-bold">Año:</span> {flightData.year} </p>
                    </div>
                </div>

                <table className="table table-striped mt-3">
                    <thead className="text-center">
                        <tr>
                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>Master</th>
                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>Houses</th>
                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>Destino</th>
                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>Fecha ingreso</th>
                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>ULD / XP / PL</th>
                            <th style={{ backgroundColor: '#020C41', color: 'white', width: '9%' }}>Piezas</th>
                            <th style={{ backgroundColor: '#020C41', color: 'white', width: '9%' }}>Peso</th>
                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>Contenido</th>
                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>Locaciones</th>
                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>Motivo</th>
                            <th style={{ backgroundColor: '#020C41', color: 'white' }}>Acciones</th>
                        </tr>
                    </thead>
                    <tbody className="text-center">
                    {allData.exp_masters.map(master => (
                        <tr className="text-center lags-table" key={master.id}>
                            <td>{master.master}</td>
                            <td>
                                <select 
                                    className={`form-select ${isEditable ? '' : 'input-lags-disabled'}`} 
                                    disabled={!isEditable}
                                    onChange={(e) => {
                                        const selected = Array.from(e.target.selectedOptions, option => option.value);
                                        setHouses(selected);
                                    }}
                                >
                                    <option value="">Seleccionar</option>
                                    <option value="house1">House 1</option>
                                    <option value="house2">House 2</option>
                                </select>
                            </td>
                            <td></td>
                            <td></td>
                            <td>
                                <input
                                    type="text"
                                    className={`form-control ${isEditable ? '' : 'input-lags-disabled'}`}
                                    placeholder="ULD / XP / PL"
                                    disabled={!isEditable}
                                    value={uldXpPl}
                                    onChange={(e) => setUldXpPl(e.target.value)}
                                />
                            </td>
                            <td>
                                <input
                                    type="number"
                                    className={`form-control ${isEditable ? '' : 'input-lags-disabled'}`}
                                    placeholder="Piezas"
                                    disabled={!isEditable}
                                    value={pieces}
                                    onChange={(e) => setPieces(e.target.value)}
                                />
                            </td>
                            <td>
                                <input
                                    type="number"
                                    className={`form-control ${isEditable ? '' : 'input-lags-disabled'}`}
                                    placeholder="Peso"
                                    disabled={!isEditable}
                                    value={weight}
                                    onChange={(e) => setWeight(e.target.value)}
                                />
                            </td>
                            <td>Consolidado</td>
                            <td>A303,A304</td>
                            <td>
                                <textarea
                                    className={`form-control ${isEditable ? '' : 'input-lags-disabled'}`}
                                    rows="1"
                                    placeholder="Motivo"
                                    disabled={!isEditable}
                                    value={reason}
                                    onChange={(e) => setReason(e.target.value)}
                                />
                            </td>
                            <td>Con rezago <input type="checkbox" checked={isEditable} onChange={handleCheckboxChange} /></td>
                        </tr>
                    ))}
                    </tbody>
                </table>

                <div className="row">
                    <div className="col-6">
                        <label for="user" class="amc-label">Quien captura *</label>
                        <input 
                            type="text"
                            class="form-control input-lags-disabled"
                            name="user"
                            value={userName}
                            disabled
                        />
                    </div>
                    <div className="col-6">
                        <label for="coordinator" class="amc-label">Coordinador *</label>
                        <input 
                            type="text"
                            class="form-control"
                            name="coordinator"
                            value={coordinator}
                            onChange={(e) => setCoordinator(e.target.value)}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="col mt-4 d-flex justify-content-end">
                        <button className='btnn' onClick={handleSave} >Guardar</button>
                    </div>
                </div>
            </div>
        </>
    );
}

export default LagsForm;